import React from 'react';
import { N600 } from '@atlaskit/theme/colors';
import ChatIcon from '@atlaskit/icon/core/migration/comment';
export var extractCommentCount = function extractCommentCount(jsonLd) {
  var commentCount = jsonLd['schema:commentCount'];
  if (commentCount) {
    return {
      text: commentCount.toString(),
      icon: /*#__PURE__*/React.createElement(ChatIcon, {
        label: "comment-count",
        key: "comments-count-icon",
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, ".concat(N600, ")")
      })
    };
  }
};